import React, { Component } from "react";
import { Col, Row } from "react-bootstrap";
import ToggleBar from "../../commoncomponents/toggleBar";

class TempSummary extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  componentDidMount() {}

  render() {
    return (
      <ToggleBar caption="Summary" color="#337AB7" icon="fa-bar-chart" toggle="off" generated={this.props.generated}>
      <div className="summary-outer">

        <div className="summary-container">
          <div className="summary-header">

          </div>
          <div className="summary-content">
            <Row>
              <Col sm="4">
                <div className="divFlex">
                  <i className="fa fa-hourglass-start"></i>
                  <h4>{`Start: ${this.props.start? this.props.start: null}`}</h4>
                </div>
                <div className="divFlex">
                  <i className="fa fa-hourglass-end"></i>
                  <h4>{`End: ${this.props.end}`}</h4>
                </div>
                <div className="divFlex">
                  <i className="fa fa-clock-o"></i>
                  <h4>{`Duration: ${this.props.duration}`}</h4>
                </div>
              </Col>
              <Col sm="8">
                <div className="divFlex">
                  <i className="fa fa-table "></i>
                  <h4>{`Temperature Logs: ${this.props.logNumber}`}</h4>
                </div>
                <div className="divFlex">
                  <i className="fa fa-thermometer-full"></i>
                  <h4>{`Temp Exceptions:${this.props.exceptionNumber}`}</h4>
                </div>
              </Col>
            </Row>
          </div>
        </div>
      </div>

      </ToggleBar>



    );
  }
}

export default TempSummary;
